export default __webpack_public_path__ + "static/media/css3-original.9cecabbf.svg";